// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-administrator-invoice-container{
    position: absolute;
    top: 2vh;
    right: 0px;
    height: 95%;
    width: 0%;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 5px 0px 0px 5px;
    background-color: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    animation: customer-administrator-invoice-container-stretch-in 0.45s ease-out forwards;
}
@keyframes customer-administrator-invoice-container-stretch-in {
    from{
        width: 0%;
    }
    to{
        width: 70%;
    }
}
.customer-administrator-invoice-container-header{
    padding: 15px;
    border-radius: 5px 0px 0px 0px;
    display: flex;
    justify-content: space-between;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
}
.customer-administrator-invoice-container-header h3{
    margin: 0px;
    font-weight: lighter;
}
.customer-administrator-invoice-container-header p{
    margin: 0px;
    margin-right: 20px;
    font-weight: lighter;
    font-size: 30px;
    cursor: pointer;
}
.customer-administrator-invoice-container-header h4{
    margin: 0px;
    font-weight: lighter;
    font-size: 14px;
}
.customer-administrator-invoice-navigation-bar{
    border-bottom: 1px solid rgb(218, 218, 218);
}
.customer-administrator-invoice-navigation-bar button{
    border: none;
    cursor: pointer;
    padding: 10px;
    font-size: 13px;
    color: rgb(66, 66, 66);
    background-color: transparent;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.customer-administrator-invoice-navigation-bar button.active{
    border-bottom: 2px solid rgba(155, 30, 30, 0.952);
}
.customer-administrator-invoice-container-body{
    position: relative;
}
.customer-administrator-loading-selected-invoice-container{
    text-align: center;
    padding-top: 25vh;
}
.customer-administrator-loading-selected-invoice-container div{
    height: 32px;
    width: 32px;
    display: inline-block;
    border: 2px solid brown;
    border-top-color: transparent;
    border-radius: 50%;
    animation: customer-administrator-loading-selected-invoice-spinner 0.8s linear infinite;
}
@keyframes customer-administrator-loading-selected-invoice-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.customer-administrator-loading-selected-invoice-container p{
    font-size: 15px;
    color: rgb(58, 58, 58);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/CustomerAdministratorStyles/Invoices/Invoice/Invoice.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,sCAAsC;IACtC,sFAAsF;AAC1F;AACA;IACI;QACI,SAAS;IACb;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,eAAe;AACnB;AACA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,6BAA6B;IAC7B,gDAAgD;AACpD;AACA;IACI,iDAAiD;AACrD;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,uFAAuF;AAC3F;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,4DAA4D;AAChE","sourcesContent":[".customer-administrator-invoice-container{\n    position: absolute;\n    top: 2vh;\n    right: 0px;\n    height: 95%;\n    width: 0%;\n    overflow: hidden;\n    box-sizing: border-box;\n    border-radius: 5px 0px 0px 5px;\n    background-color: white;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n    animation: customer-administrator-invoice-container-stretch-in 0.45s ease-out forwards;\n}\n@keyframes customer-administrator-invoice-container-stretch-in {\n    from{\n        width: 0%;\n    }\n    to{\n        width: 70%;\n    }\n}\n.customer-administrator-invoice-container-header{\n    padding: 15px;\n    border-radius: 5px 0px 0px 0px;\n    display: flex;\n    justify-content: space-between;\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n}\n.customer-administrator-invoice-container-header h3{\n    margin: 0px;\n    font-weight: lighter;\n}\n.customer-administrator-invoice-container-header p{\n    margin: 0px;\n    margin-right: 20px;\n    font-weight: lighter;\n    font-size: 30px;\n    cursor: pointer;\n}\n.customer-administrator-invoice-container-header h4{\n    margin: 0px;\n    font-weight: lighter;\n    font-size: 14px;\n}\n.customer-administrator-invoice-navigation-bar{\n    border-bottom: 1px solid rgb(218, 218, 218);\n}\n.customer-administrator-invoice-navigation-bar button{\n    border: none;\n    cursor: pointer;\n    padding: 10px;\n    font-size: 13px;\n    color: rgb(66, 66, 66);\n    background-color: transparent;\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\n}\n.customer-administrator-invoice-navigation-bar button.active{\n    border-bottom: 2px solid rgba(155, 30, 30, 0.952);\n}\n.customer-administrator-invoice-container-body{\n    position: relative;\n}\n.customer-administrator-loading-selected-invoice-container{\n    text-align: center;\n    padding-top: 25vh;\n}\n.customer-administrator-loading-selected-invoice-container div{\n    height: 32px;\n    width: 32px;\n    display: inline-block;\n    border: 2px solid brown;\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: customer-administrator-loading-selected-invoice-spinner 0.8s linear infinite;\n}\n@keyframes customer-administrator-loading-selected-invoice-spinner {\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.customer-administrator-loading-selected-invoice-container p{\n    font-size: 15px;\n    color: rgb(58, 58, 58);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
